module.exports = __webpack_public_path__ + "static/media/Roy.485764fc.png";